export const enum Permissions {
  USERS_READ = 'cp:read:users',
  ROLES_READ = 'cp:read:roles',
  ROLES_UPDATE = 'cp:update:roles',
  ORGANIZATIONS_READ = 'cp:read:organizations',
}
